module.exports = __webpack_public_path__ + "static/media/logo_cameras.2e5439a4.png";